import React from "react";
import { PeekTypography, useTheme } from "@piiqtechnologies/ui-components";
export const CustomSubtitle = ({ subtitle }) => {
    const theme = useTheme();
    return (React.createElement(PeekTypography, { variant: "body1", color: theme.palette.grey[400] }, subtitle));
};
export default CustomSubtitle;
